import { createSelector } from 'reselect'
import { hasPremiumUserSelect } from 'modules/training/modules/training-users/selectors/has-premium'
import { hasFreeTrialEndedUserSelect } from 'modules/training/modules/training-users/selectors/has-free-trial-ended/index.js'
import { getSubscriptionPlanUserSelect } from 'modules/training/modules/training-users/selectors/get-subscription-plan/index.js'
import { SUBSCRIPTION_PLAN } from '@gymaholic/packages'
import { getSubscriptionCanceledAtUserSelect } from 'modules/training/modules/training-users/selectors/getSubscriptionCanceledAt/index.js'
import { hasPremiumPlusUserSelect } from 'modules/training/modules/training-users/selectors/has-premium-plus/index.js'

export const shouldShowUpgradeDiscountUserSelect = createSelector(
  hasPremiumUserSelect,
  hasPremiumPlusUserSelect,
  hasFreeTrialEndedUserSelect,
  getSubscriptionPlanUserSelect,
  getSubscriptionCanceledAtUserSelect,
  (
    hasPremium,
    hasPremiumPlus,
    hasFreeTrialEnded,
    subscriptionPlan,
    subscriptionCancelledAt
  ) => {
    if ([
      SUBSCRIPTION_PLAN.PREMIUM_PLUS_UPGRADE_2025,
      SUBSCRIPTION_PLAN.PREMIUM_PLUS_YEARLY_UPGRADE_2025
    ].includes(subscriptionPlan)) {
      return true
    }

    return !!(
      hasPremium &&
      hasFreeTrialEnded &&
      !hasPremiumPlus &&
      !subscriptionCancelledAt
    )
  }
)
